import { createStyles } from '@mantine/core'

export default createStyles((theme, _params, getRef) => ({
  date: {
    lineHeight: '20px',
  },
}))
